import { ContactsDTO } from "../domain/models/dto/ContactsDTO";
import { IContacts } from "../domain/models/Contacts";
import { ContactsModel } from "../models/ContactsModel";
import { SimpleMapper } from "./SimpleMapper";

export class ContactsMapper extends SimpleMapper<IContacts, ContactsDTO> {
    protected toDTOFields: string[] = ["id", "address", "phone", "email", "directorId"];
    protected fromDTOFields: string[] = [
        ...this.toDTOFields,
        "creatorId",
        "createdAt",
        "updatedAt",
        "updatorId",
    ];
    protected entityConstructor = ContactsModel;
}

